<template>
  <LayoutGradient title="Faixa de Resultado" icon="fa-list">
    <template v-slot:headerRight>
      <b-btn-group>
        <b-btn variant="outline-info" @click="$router.back()">
          <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
        </b-btn>        
      </b-btn-group>
    </template>

    <b-overlay :show="isLoading" class="m-3 mt-n10" no-center>
      <template v-slot:overlay>
        <div class="d-flex mt-5">
          <div class="m-auto">
            <b-icon icon="stopwatch" font-scale="3" animation="cylon"/>
            <p>Carregando...</p>
          </div>
        </div>
      </template>
      <b-card class="m-3 mt-n10">
        <b-form @submit="onSubmit">          
          <b-form-group
              label-cols-sm="4"
              label-cols-lg="3"
              :description="$t('vns.form.fields.integracao_origem.description')"
              :label="$t('vns.form.fields.integracao_origem.label')"
              label-for="input-integracao_origem"
              class="col"
          >
            <b-overlay :show="integrationsLoading">
              <v-select
                  id="input-integracao_origem"
                  class="w-100"
                  :value="resultrange.vns_integration_origin_id"                  
                  :options="integrations"
                  :reduce="option => option.id"
                  label="name"
                  v-model="resultrange.vns_integration_origin_id"
              />
            </b-overlay>
          </b-form-group>

          <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.integracao_destino.description')"
                :label="$t('vns.form.fields.integracao_destino.label')"
                label-for="input-integracao_destino"
                class="col"
            >
              <b-overlay :show="integrationsLoading">
                <v-select
                    id="input-integracao_destino"
                    class="w-100"
                    :value="resultrange.vns_integration_destination_id"
                    :options="integrations"
                    :reduce="option => option.id"
                    label="name"
                    v-model="resultrange.vns_integration_destination_id"
                />
              </b-overlay>
          </b-form-group>

          <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                description="Exame pertencente a configuração da faixa de resultado"
                label="Exame"
                label-for="input-integracao_destino"
                class="col">
            <b-overlay :show="isLoading">
              <SelectTuevsExam class="mb-3" v-model="resultrange.tuevs_exam" :model="resultrange.tuevs_exam" />
            </b-overlay>
          </b-form-group>

          <b-form-group
              label="Status"
              description="Status da faixa de resultado"
              label-for="input-status"
          >
            <b-form-checkbox
                id="input-status"
                v-model="resultrange.status"
                value=1
                unchecked-value=0
                size="lg"
                switch
            />
          </b-form-group>

          <b-button type="submit" variant="success">
            <i class="fas fa-save"/> Salvar
          </b-button>
        </b-form>
      </b-card>
    </b-overlay>
  </LayoutGradient>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import LayoutGradient from "@/templates/LayoutGradient";
import DeXParaRepository from "@/repositories/dexpara/ResultRangeRepository";
import SelectTuevsExam from "@/components/tuevs/Select/SelectTuevsExam";

export default {
  name: "Form",
  components: {LayoutGradient, SelectTuevsExam},
  computed: {
    ...mapGetters({
      resultranges: 'dexpara/resultrange/all',
      resultrange: 'dexpara/resultrange/current',
      isLoading: 'dexpara/resultrange/isLoading',
      integrations: 'integration/all',
      integrationsLoading: 'integration/isLoading',
    }),
  },
  data() {
    return {
      fields: [
        {label: 'Integração de Origem', name: 'vns_integration_origin_id', description: 'Origem'},
        {label: 'Integração de Destino', name: 'vns_integration_destination_id', description: 'Destino'},
        {label: 'Exame', name: 'tuevs_exam_id', description: 'Exame'},
        {label: 'Status', name: 'status', description: 'Status'},
      ]
    }
  },
  methods: {
    ...mapActions([
      'dexpara/resultrange/listOne',
      'integration/search',
    ]),    
    onSubmit() {
      if (this.$route.params.id) {
        this.update()
      }else {
        this.create()
      }
    },
    create() {
      let newModel = this.resultrange;
      newModel.tuevs_exam_id = this.resultrange.tuevs_exam.value;
      delete newModel.tuevs_exam;

      DeXParaRepository.post(newModel).then(() => {
        this.$snotify.success(`Configuração de range de resultado criada com Sucesso`)
        this.$router.push({name: 'resultrange.index'})
      }).catch(error => {
        if (error.response.status === 422) {
          DeXParaRepository.toastValidationErrors(error, this.$snotify)
        }
      })      
    },
    update() {
      let newModel = this.resultrange;
      newModel.tuevs_exam_id = this.resultrange.tuevs_exam.value;
      delete newModel.tuevs_exam;

      DeXParaRepository.put(newModel.id, newModel).then(() => {
        this.$snotify.success(`Configuração de range de resultado atualizada com Sucesso`)
        this.$router.push({name: 'resultrange.index'})
      }).catch(error => {
        if (error.response.status === 422) {
          DeXParaRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.resultrange.status = 0;
    this['integration/search']()
    this.$store.commit('dexpara/resultrange/setCurrent', {})
    
    if (this.$route.params.id) {
      await this['dexpara/resultrange/listOne'](this.$route.params.id)
      this.resultrange.tuevs_exam = { "label": this.resultrange.tuevs_exam_name, "value": this.resultrange.tuevs_exam_id }
    }
  }
}
</script>

<style scoped>
</style>